import { z } from 'zod';

export const messageReplySuggestionSchema = z.object({
  content: z.string(),
  uuid: z.string(),
});

export type MessageReplySuggestion = z.infer<
  typeof messageReplySuggestionSchema
>;

export const messageReplyResponseSchema = z.object({
  userId: z.string(),
  contactId: z.string(),
  messages: z.array(messageReplySuggestionSchema),
  parentMessageId: z
    .string()
    .describe(
      'The message id of the message that the suggestions are for. If your ID is number,  you should convert this value to string.',
    ),
});

export type MessageSuggestionsResponse = z.infer<
  typeof messageReplyResponseSchema
>;
